import OrderIcon from '@mui/icons-material/AttachMoney';
import Dashboard from './Dashboard';
export default {
    list: Dashboard,
    icon: OrderIcon,
    recordRepresentation: 'reference',
};
